import { Logo } from "@/components/Logo";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong" };
  }

  componentDidCatch(error, info) {
    // Stale bundle after a deploy -> chunk load fails -> auto-recover once
    const msg = String(error?.message || error || "");
    const isChunkError = /ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch dynamically/i.test(msg);
    if (isChunkError && !sessionStorage.getItem("rdf_chunk_reloaded")) {
      sessionStorage.setItem("rdf_chunk_reloaded", "1");
      window.location.reload();
      return;
    }
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
  }

  handleReload = () => {
    try { sessionStorage.removeItem("rdf_chunk_reloaded"); } catch (e) {}
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-6 text-center">
          <Logo className="h-16 w-16 rounded-2xl mb-5" />
          <h1 className="font-display text-2xl font-bold mb-2">Something glitched</h1>
          <p className="text-muted-foreground text-sm max-w-[320px] mb-6">
            The app hit an unexpected error. Reloading usually fixes it.
          </p>
          <button
            data-testid="error-reload-button"
            onClick={this.handleReload}
            className="h-12 px-8 rounded-xl bg-[#ccff0c] text-black font-semibold hover:bg-[#d7ff3a]"
          >
            Reload app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
